import { Directive } from '@angular/core';
/**
 * @hidden
 */
var ItemContent = (function () {
    function ItemContent() {
    }
    ItemContent.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-item,[ion-item]',
                    host: {
                        'class': 'item-block'
                    }
                },] },
    ];
    /** @nocollapse */
    ItemContent.ctorParameters = function () { return []; };
    return ItemContent;
}());
export { ItemContent };
//# sourceMappingURL=item-content.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-angular/components/item/item-content.js
// module id = 136
// module chunks = 1